/**
 * Карточка заказа: «Куда ушёл товар» — принятые штуки по корзинам.
 *
 * Спека: `docs/specs/2026-10-19-order-goods-where-design.md`. Корзины, суммы и
 * подписи подробностей считает сервер; здесь — типы, загрузка и подсказка.
 */

import { apiFetch } from "@/lib/api";
import { num } from "@/lib/format";

export type WhereDetail = { label: string; units: number; href: string | null };
export type WhereCell = { units: number; details: WhereDetail[] };
export type WhereBucket = WhereCell & { key: string; label: string };
export type OrderWhere = {
  received: number;
  buckets: WhereBucket[];
  positions: { position_id: number; received: number; cells: Record<string, WhereCell> }[];
  without_position: number;
};

export function loadOrderWhere(orderId: number): Promise<OrderWhere> {
  return apiFetch<OrderWhere>(`/api/orders/${orderId}/where`);
}

/** Подсказка ячейки: «подпись — N» строками; длинный хвост — «и ещё K (M шт)». */
export function detailsTitle(details: WhereDetail[], limit = 12): string {
  const видно = details.slice(0, limit).map((d) => `${d.label} — ${num(d.units)}`);
  const хвост = details.slice(limit);
  if (хвост.length)
    видно.push(`и ещё ${хвост.length} (${num(хвост.reduce((n, d) => n + d.units, 0))} шт)`);
  return видно.join("\n");
}
